import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { installErrorReporter } from "./lib/errorReporter";

// Capture uncaught errors + promise rejections so admins can review them
// in /admin/debug. Safe in dev and prod; deduped + filters out known noise.
installErrorReporter();

// PWA service worker — only register in production, outside iframes/preview hosts.
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("id-preview--") ||
    window.location.hostname.includes("lovableproject.com") ||
    window.location.hostname.includes("lovable.app"));

if (isPreviewHost || isInIframe) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
}
// Production SW registration with update detection happens inside
// <PwaUpdatePrompt /> so we can show the user a "Reload" prompt.

createRoot(document.getElementById("root")!).render(<App />);
